import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

import ResponseTimeGeneralLight from '../../../Online/components/ResponseTime/ResponseTimeGeneralLight';
import ResponseTimeRankTable from '../../../Online/components/ResponseTime/ResponseTimeRankTable';
import AvailabilityGaugeChartLight from '../../../Online/components/AvailabilityGauge/AvailabilityGaugeChartLight';
import ErrorsEventsObjective from '../../../Online/components/ErrorsEventsObjective';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter } from 'react-router-dom';


// Shared components
import Portlet from 'components/Portlet';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ClearIcon from '@material-ui/icons/Clear';

// Palette
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'
import { getQueryParams } from '../../../../utils/fns/get-query-params';
import { Box, DialogContent, DialogTitle } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
moment.locale('es')


class ListObjectiveModal extends Component {

    constructor(props) {
        super(props);
        //console.log('list', props)
        this.handleResponseClick = this.handleResponseClick.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleNodeClick = this.handleNodeClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        this.state = {
            typeGraph: 0,
            period: 'd',
            step: 0,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [' Consolidado', ' Detalle por Paso', ' Detalle por Monitor'],
            namePeriodPorlet: [this.props.t('period.text.last-hour'), this.props.t('period.text.last-day')],
            typePeriod: 1,
            //nameSelectStep: "Seleccione Paso"
            nameSelectStep: "Información Extendida ",
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: false,
            date: new Date(),
            dateMoment: ((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            detalleGraph:[' Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el período y horario seleccionado.', 
                        ' Corresponde a la información estadística de los tiempos de respuestas del objetivo, separado por paso, durante el período y horario seleccionado.',
                        ' Corresponde a los tiempos de respuesta del objetivo,para cada ISP desde donde se monitorea el objetivo, separado por paso, durante el período y horario seleccionado.'],
            listObjectives: this.props.listObjective,
            objId: this.props.obj,
            mediciones: 0
        };
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
     }
     
     tick() {
         /*if(this.state.checkedA===true){
             this.setState({
             date: new Date(),
             dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
             });
         }*/
     }

    handleResponseClick() {
        /*this.setState({
            typeGraph: 0,
            isForStep: false,
            isLastEvent: false,
            responseTimeGraphEl: null,
            nameSelectStep: "Seleccione Paso",
            isRefresh: false
        });*/
    }

    handleStepClick() {
        /*this.setState({
            typeGraph: 1,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false
        });*/
    }

    handleNodeClick() {
       /* this.setState({
            typeGraph: 2,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false
        });*/

    }

    handlePeriodClick(nextPeriod) {
       /* if (nextPeriod === 'hora') {
            this.setState({
                //typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } */
    }
    
    handleNextStepClick = event => {
        /*const newSelectStep = event.currentTarget.name
        const newStep = event.currentTarget.id
        if (this.state.step !== newStep) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                extendEl: null,
                nameSelectStep: newSelectStep,
                isRefresh: false
            })
        }*/
    }
    handleInfo(props, step) {
       /* let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()

        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        this.setState({
            nameStep: step,
            x: newDate.toLocaleString(),
            y: props.y
        })*/
    }


    handleFirstInfo(props) {        
        if (this.state.mediciones !== props) {
            this.setState({
                mediciones: props,               
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            //isRefresh: false
        })
    }

    handleShowResponseTimeGraph = event => {
       /* this.setState({
            responseTimeGraphEl: event.currentTarget
        });*/
    };

    handleCloseResponseTimeGraph = () => {
        /*this.setState({
            responseTimeGraphEl: null
        });*/
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget,
           
        });
    };

    handleClosePeriod = event => {
        this.setState({
            periodEl: null,
            period: event.currentTarget.value,
            typePeriod: event.currentTarget.id
        });
    };
    handleClosePeriodSecondary = event => {
        this.setState({
            periodEl: null,
        });
    };

    handleShowExtend = event => {
       /* this.setState({
            extendEl: event.currentTarget
        });*/
    };

    handleCloseExtend = () => {
        /*this.setState({
            extendEl: null
        });*/
    };

    handleRefresh = event => {
       /* this.setState({
            isRefresh: true,
            settingsEl: null,
        })*/
    }

    handleShowSettings = event => {
       /* this.setState({
            settingsEl: event.currentTarget
        });*/
    };
    handleShowIsInfo = event => {
        /*this.setState({
            isInfo: event.currentTarget
        });*/
    };
    handleCloseSettings = () => {
       /* this.setState({
            settingsEl: null
        });*/
    };
    handleCloseIsInfo = () => {
        /*this.setState({
            isInfo: null
        });*/
    };
    handleChange = name=>event => {
        /*this.setState({ 
            checkedA: event.target.checked 
        });
        this.timerID = setInterval(
            () => this.tick(),
            300000
          );*/
      };

    componentDidUpdate(prevProps, prevState) {
        
    }

    render() {

        const { classes, className, handleClose, location, listObjectives, obj, ...rest } = this.props;
        const {
            periodEl,namePeriodPorlet, typePeriod
        } = this.state;
  
        const showPeriodEl = Boolean(periodEl);
        const objective = [] 
        Object.keys(listObjectives).map(key => {   
            if (key !== 'Services' && key !=='ServicesUnified' && key !== 'NoMonitoringPartial'){
                Object.keys(listObjectives[key]).map(key2 => {
                    if (listObjectives[key][key2].objetivo_id == obj){
                        objective.push(listObjectives[key][key2]);
                    }
                })
            }     
        })
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (!this.state.dataError) {
            return (                
                <>                    
                    <DialogTitle>
                        <Box display='flex' justifyContent='space-between' alignItems='center'>
                        <Typography variant='h4' className='card__text--dark-color'>{this.props.objName}</Typography>
                        <PortletToolbar>
                            <Button variant="h4" style={{fontSize:'15px',float:'left'}} onClick={this.handleShowPeriod}>
                                {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                            </Button>
                            <IconButton onClick={handleClose}><ClearIcon/></IconButton>
                            <Popover
                                anchorEl={periodEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleClosePeriodSecondary}
                                open={showPeriodEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <List>
                                    <ListItem>
                                    <Button color='primary' style={{color:'#353535'}} value={'h'} id={0} onClick={this.handleClosePeriod} className="button muted-button">{t('period.text.last-hour')}</Button>
                                    </ListItem>
                                    <ListItem>
                                    <Button color='primary' style={{color:'#353535'}} value={'d'} id={1} onClick={this.handleClosePeriod} className="button muted-button">{t('period.text.last-day')}</Button>
                                    </ListItem>
                                </List>
                            </Popover>
                        </PortletToolbar>
                        </Box>
                    </DialogTitle>
                    
                    <DialogContent className={classes.content}>
                        
                        <Grid
                            container
                            spacing={5}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={7}
                                xl={7}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >        
                                    {<Graph props={this.props} state={this.state} onDateMoment={this.handleDateMoment}/>}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={5}
                                xl={5}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >   
                              {/*   <div style={{float:"right"}}>
                                    <div style={{float:"left"}}>
                                        <QueryBuilderIcon/>
                                    </div>
                                    <Typography  style={{width:"350px", height:"1px", float:"right", marginTop:"5px", paddingLeft:"3px"}} color="textSecondary">
                                        Última Actualización {dateMoment}
                                    </Typography>
                                </div> */}
                                    <GraphGauge props={this.props} state={this.state} />
                                    {<Link to={{
                                        pathname: `/online/${objective.length > 0 ? objective[0].objetivo_id : 0}/${objective.length > 0  ? objective[0].nombre : ''}/${objective.length > 0  ? objective[0].nombre_servicio_unificado : ''}`,
                                        search: getQueryParams(),
                                        state: {
                                            fromObjective: objective[0]
                                        }
                                    }}> 

                                    <br />
                                    <br />
                                    <br />

                                    <div>
                                        <Button id={objective.length > 0 ? objective[0].nombre_servicio_unificado : ''}>
                                        {t('modal.objective.button.go-to-details')} <ArrowRightIcon />
                                        </Button>
                                    </div>
                                </Link>}
                              
                            </Grid>
                            
                            
                        </Grid> 
                        
                        <Grid
                            container
                            spacing={5}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                xl={6}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >
                                    <Portlet style={{border: "0px"}}>                                        
                                        <PortletContent>
                                            <div style={{float:"left",  marginLeft:"1%", marginBottom:"-1%"}}>

                                                <PortletLabel
                                                variant="h6"
                                                title={t('modal.objective.slow-transactions.title')} 
                                                />
                                            
                                            </div> 
                                            </PortletContent>   
                                           
                                            <div >
                                                {<TableRank props={this.props} state={this.state}/>}
                            
                                            </div>
                                    </Portlet>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                xl={6}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >   
                                        <div style={{float:"center", backgroundColor:"#373537"}}>
                                            {<TableError props={this.props} state={this.state} onFirstInfo={this.handleFirstInfo}/>}                                
                                        </div>                             
                            </Grid>                            
                        </Grid>     
                        
                    </DialogContent>
                </>
               

            )
        }
        else if (this.state.dataError) {
            return (<p>{t('modal.objective.render.no-data')}</p>)
        }
        else if (this.state.isLoading) {
            return (<p style={{color:"white"}}>{t('text.loading')}</p>)
        }
        else if (this.state.externalData == null) {
            return (<p style={{color:"white"}}>{t('text.loading')}</p>)
        }
        else return (<p>{t('modal.objective.render.error')}</p>)
    }
}

function Graph(props, state) {    
    
    return <ResponseTimeGeneralLight params={props} state ={state}/>;
  
}
function GraphGauge(props, state) {  
    
    return <AvailabilityGaugeChartLight params={props} state ={state}/>;
  
}

function TableRank(props, state) {  
    
    return <ResponseTimeRankTable params={props} state ={state}/>;
  
}

function TableError(props, state) {  
    
    return <ErrorsEventsObjective params={props} state ={state}/>;
  
}


export default
    compose(withRouter, withStyles(styles), withTranslation())(ListObjectiveModal);